// extracted by mini-css-extract-plugin
module.exports = {"card":"CustomerReviewCard_card__nTKJf","image":"CustomerReviewCard_image__hP77K"};